import {
  useEffect,
  useRef,
  useState
} from 'react'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure
} from '@chakra-ui/react'
import {
  getEditProfileMessage,
  setIsChangesSaved,
  setIsProfileIncomplete,
  setUserSectionPage,
  usersSelectors
} from 'store'
import {
  EDIT_PROFILE,
  PLATFORM_LIST
} from 'utils/constants'

export const DiscardChanges = ({
  isDiscard,
  setIsDiscard,
  isProfileIncomplete,
  isClickedOutside
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { userSectionPage } = useSelector(usersSelectors)

  const finalRef = useRef(null)
  const [isIncomplete, setIsIncomplete] = useState(false)

  const dispatch = useDispatch()

  const handleDiscardChanges = () => {
    if (isProfileIncomplete === true) {
      setIsIncomplete(true)
    } else {
      dispatch(getEditProfileMessage({
        message1: [],
        message2: []
      }))
      setIsDiscard(false)
      dispatch(setIsProfileIncomplete(false))
      dispatch(setIsChangesSaved(true))
      onClose()
    }
  }

  const handleIncompleteChanges = () => {
    setIsDiscard(false)
    setIsIncomplete(false)
    onClose()
  }

  const handleCloseDiscard = () => {
    setIsDiscard(false)
    dispatch(setIsProfileIncomplete(false))
    dispatch(getEditProfileMessage({
      message1: [],
      message2: []
    }))

    if (isClickedOutside === true) {
      dispatch(setUserSectionPage('clear'))
    } else {
      dispatch(setUserSectionPage(null))
    }

    onClose()
  }

  const handleCloseButtonDiscard = () => {
    setIsDiscard(false)
    onClose()
  }

  useEffect(() => {
    if (isDiscard === true) {
      onOpen()
    }
  }, [isDiscard])

  return (
    <Modal
      isCentered
      finalFocusRef={finalRef}
      isOpen={isOpen}
      onClose={handleCloseButtonDiscard}
    >
      <ModalOverlay zIndex={1412} />
      <ModalContent containerProps={{ zIndex: 1413 }}>
        <ModalCloseButton />
        <ModalHeader>Save Changes</ModalHeader>

        <ModalBody>
          {
            isIncomplete === true
              ? <Text>Your profile is incomplete</Text>
              : <Text>Are you sure you want to save your changes?</Text>
          }
        </ModalBody>

        <ModalFooter>
          {
            isIncomplete === true
              ? (
                <Button
                  colorScheme="yellow"
                  name="reset-yes"
                  mr={3}
                  onClick={() => handleIncompleteChanges()}
                >
                  Ok
                </Button>
              ) : (
                <>
                  <Button
                    colorScheme="yellow"
                    name="reset-yes"
                    mr={3}
                    onClick={() => {
                      const drawerContents = document.querySelector(`#${EDIT_PROFILE}-drawer-body`)
                      if (drawerContents) {
                        drawerContents.scrollTop = drawerContents.scrollHeight
                      }

                      if (userSectionPage.at(-1) === PLATFORM_LIST) {
                        dispatch(setUserSectionPage(null))
                      }

                      handleDiscardChanges()
                    }}
                  >
                    Yes
                  </Button>

                  <Button
                    mr={3}
                    onClick={() => handleCloseDiscard()}
                    name="reset-no"
                  >
                    No
                  </Button>
                </>
              )
          }
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
